import { Children } from "react";
import { MailTo } from "@sequoiacap/client-ui";
import classNames from "classnames";

type FeedbackPromptProps = {
  children?: React.ReactNode;
};

export function FeedbackPrompt(props: FeedbackPromptProps): JSX.Element {
  return <div className="feedback-prompt">{props.children}</div>;
}

type FeedbackMailToProps = React.ComponentPropsWithoutRef<"a"> & {
  className?: string;
  pageTitle: string;
  subject?: string;
};
/**
 * NOTE: you cannot specify children. We want the mailto text to be the email address so user can copy-paste the link. Otherwise, clicking the link will open the mail client on mac (typically not someone's gmail)
 */
export function FeedbackMailTo(props: FeedbackMailToProps): JSX.Element {
  if (Children.count(props.children)) {
    console.warn(
      "Children not allowed in FeedbackMailTo. They will not be rendered",
    );
  }
  let feedbackDest: string;
  if (process.env.APP_ENV === "dev") {
    feedbackDest = "feedback-dev@ampersand.sequoiacap.com";
  } else {
    feedbackDest = "ampersand@sequoiacap.com";
  }

  return (
    <MailTo
      className={classNames("lit", props.className)}
      emailAddress={feedbackDest}
      subject={props.subject || `Feedback on '${props.pageTitle}'`}
    >
      {feedbackDest}
    </MailTo>
  );
}
